import { getQueryClient } from '$lib/state/queryClient';
import { fetchProjects } from '$lib/api/project';
import { fetchUnits } from '$lib/api/unit';
import type { Project } from '$lib/types/project';
import type { Unit } from '$lib/types/unit';
import { projectsQueryKey, projectsQueryOptions } from '$lib/queries/projects';
import { unitsQueryKey, unitsQueryOptions } from '$lib/queries/units';

export async function fetchProjectById(projectId: number): Promise<Project | null> {
	const qc = getQueryClient();
	const cached = qc.getQueryData<Project[]>(projectsQueryKey);
	if (cached) return cached.find((p) => p.id === projectId) ?? null;
	const projects = await qc.fetchQuery(projectsQueryOptions());
	return projects?.find((p) => p.id === projectId) ?? null;
}

export async function fetchUnitById(unitId: number): Promise<Unit | null> {
	const qc = getQueryClient();
	const cachedUnits = qc.getQueriesData<Unit[]>({ queryKey: ['units'] });
	for (const [, data] of cachedUnits) {
		const unit = data?.find((u) => u.id === unitId);
		if (unit) return unit;
	}
	const all = await fetchUnits();
	const unit = all.find((u) => u.id === unitId) ?? null;
	if (unit) {
		qc.setQueryData(unitsQueryKey(unit.project), all.filter((u) => u.project === unit.project));
	}
	return unit;
}

export async function prefetchProjects() {
	return getQueryClient().prefetchQuery(projectsQueryOptions());
}
